import moment from 'moment';

export const getFormattedDate = (data, year = true) => {
  const date = moment(data);
  if (!(data && date.isValid())) return;
  return date.format(`D MMM${year ? ' YYYY' : ''}`);
};

export const date_ll = (date) => moment(date).format('ll'); // 'Jul 18, 2024'

export const getFormattedDateTime = (dateString, at = 'at', daysFromNumber = 1) => {
  const date = moment(dateString);
  if (!(dateString && date.isValid())) return;

  const currentDate = moment();
  let format = `D MMM${date.year() === currentDate.year() ? '' : ' YYYY'} [${at}] `;
  format += moment.locale() === 'en' ? 'h:mm A z' : 'H:mm';

  return daysFromNumber && currentDate.diff(date, 'days') < +daysFromNumber ? date.fromNow() : date.format(format);
};

export const getCustomFormattedDate = (dateString, outputFormat = 'D MMM YYYY') => {
  const currentDate = moment();
  const date = moment(dateString);

  if (!(dateString && date.isValid())) return;

  if (currentDate.diff(date, 'days') < 2) {
    return date.fromNow();
  }
  return date.format(outputFormat);
};

export const getDateFromSrting = (dateString, outputFormat = 'D MMM YYYY') => {
  const date = moment(dateString);

  if (!(dateString && date.isValid())) return;

  return date.format(outputFormat);
};

export const currency = (data, opts = {}) => {
  const params = {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 0,
    ...opts,
  };
  const formatter = new Intl.NumberFormat('en-US', params);
  return formatter.format(data);
};

export const capitalize = (string) => (string ? string.charAt(0).toUpperCase() + string.slice(1) : '');

export const formatNumber = (number, locale = 'en') => Intl.NumberFormat(locale).format(number);

export const SAVING_DEBOUNCE_DELAY = 1000;
export const CODE_LENGTH = 6;

export const stripeDate = (value) => date_ll(value * 1000);
export const stripeCurrency = (value) => {
  if (Number.isInteger(value)) {
    const number = value / 100;
    if (number === 0) {
      return currency(0);
    } else {
      return currency(number, { minimumFractionDigits: 2 });
    }
  }
};
export const prepareStripeInvoice = (invoiceOrigin) => {
  const invoice = structuredClone(invoiceOrigin);
  const dateFields = ['next_payment_attempt', 'period_start', 'period_end', 'created'];

  const mutation = (object, keys, func) => {
    keys.forEach((key) => {
      if (Number.isInteger(object[key])) object[key] = func(object[key]);
    });
  };

  [invoice, ...(invoice.lines || [])].map((object) => {
    mutation(object, dateFields, (value) => stripeDate(value));
  });

  return invoice;
};

export const getUniqueUsers = (users) => {
  const key = 'id';
  return [...new Map(users.map((item) => [item[key], item])).values()];
};

export const download = ({ data = null, name = 'template', url = '' } = {}) => {
  if (data || url) {
    const tempLink = document.createElement('a');
    tempLink.href = data ? window.URL.createObjectURL(data) : url;
    tempLink.setAttribute('download', `${name}.csv`);
    tempLink.click();
    URL.revokeObjectURL(tempLink.href);
  }
};

export const allowedPrice = (reward = {}) => {
  if (reward.reward_type === 'team') {
    const sum = contributedPrice(reward);
    return reward.price > sum ? reward.price - sum : 0;
  }
  return reward.price;
};

export const contributedPrice = ({ contributions = [] } = {}) => {
  return contributions.filter((p) => p.status !== 'declined').reduce((sum, a) => sum + Number(a.amount), 0);
};
